import React from "react";
import {about} from "../const";
import ContentWrapper from "../master/ContentWrapper";
import PageTitle from "../master/PageTittle";
import SideBar from "../master/SideBar";
import STRATEGICPLAN20212023 from "../../assets/about/Strategic Vision-final 27.07.2021.pdf";

const MissionContent = () => (
    <div className="container">
        <ContentWrapper sidebar={true} narrow={true}>
            <div className={"content"}>
                <PageTitle title="Mission" variant="h2"/>
                <p>
                    Inspired by the Maronite Sisters of the Holy Family, we accompany our students in the realisation of
                    their potential.
                </p>

                <PageTitle title="Vision" variant="h2"/>
                <p>
                    We challenge our community to grow in faith, strive for excellence and transform the future.
                </p>

                <PageTitle title="VISION FOR LEARNING" variant="h2"/>
                <p>
                    Our vision for learning is to engage and empower students through a Christ-centred education that
                    fosters holistic development and lifelong success.
                </p>

                <p>
                    Through 21st century practices, we guide students to grow as critical thinkers who navigate an
                    ever-changing world with resilience and compassion
                </p>

                <PageTitle title="College Values" variant="h2"/>

                <p>
                    In our learning the College seeks to foster in each child the values taught by Christ.
                </p>

                <p>
                    <strong>Integrity:</strong> To act sincerely and honestly, having
                    strong moral and ethical principles. Being true to who you truly are.
                </p>

                <p>
                    <strong>Responsibility:</strong> The ability to respond, to willingly
                    undertake the sacrifices necessary to create a productive and
                    meaningful life that is pleasing to God.
                </p>

                <p>
                    <strong>Compassion:</strong> Allows us to care for others, it refuses
                    to be selfish and is willing to forgive. It freely embraces the rich
                    diversity of humanity by treating everyone as equals and gives the
                    desire to take action to improve human lives.
                </p>
                <PageTitle title="Strategic Plan" variant="h2"/>

                <p>
                    The strategic plan determines the organisational priorities and goals for the future and guides the
                    desired outcomes for every aspect of the College. At the core of the strategic plan is the College’s
                    desire to develop young people to become fully human in the likeness of Christ, leading and
                    advocating positive transformation in our world.
                </p>

                <p>
                    The College is currently working on it 2026 – 2029 Strategic Plan, to be launched early 2026.
                </p>
            </div>
            <SideBar items={about} title="About Us"/>
        </ContentWrapper>
    </div>
);

export default MissionContent;
